var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-default',[_c('div',{staticClass:"preloader-page"},[_c('div',{staticClass:"preloader large"},[_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }